<template>
  <div>
    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuIndex: '/order/contract/own/tobe',
      menu: [
        {
          name: "待接单",
          path: '/order/contract/own/tobe',
        },
        {
          name: "运送中",
          path: '/order/contract/own/ing',
        },
        {
          name: "已送达",
          path: '/order/contract/own/arrive',
        },
        {
          name: "待审核",
          path: '/order/contract/own/uncheck',
        },
        {
          name: "已完成",
          path: '/order/contract/own/done',
        },
      ],
    };
  },
  methods: {},
  mounted() {
    this.menuIndex = this.$route.path
  },
};
</script>
